import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import TopListPanel from "@/widgets/panels/TopListEntitiesPanel.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopListSegmentsPanel',
  props: {
    isArchiveEnabled: { type: Boolean },
    isFilterEnabled: { type: Boolean },
    isFilterSetted: { type: Boolean }
  },
  emits: ["setCommonFilter", "toggleArchive", "toggleFilter"],
  setup(__props: any, { emit: __emit }) {

const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["segment:edit", "system:edit"]);
});


const emit = __emit;

const toggleArchiveParent = () => {
  emit("toggleArchive");
};

const setCommonFilterParent = (value: string) => {
  emit("setCommonFilter", value);
};

const toggleFilterParent = () => {
  emit("toggleFilter");
};

const items = ref([
  { label: "Сегмент", archive: "both" },
  { label: "Список сегментов", archive: "both", reload: true },
  { label: "Архив", archive: "archive" },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopListPanel, {
    isArchiveEnabled: _ctx.isArchiveEnabled,
    isFilterEnabled: _ctx.isFilterEnabled,
    isFilterSetted: _ctx.isFilterSetted,
    items: items.value,
    "is-button-disabled": isDenied.value,
    searchPlaceholder: "Поиск по названию",
    buttonLabel: "Создать сегмент",
    routeCreate: "segmentCreate",
    onToggleArchive: toggleArchiveParent,
    onSetCommonFilter: setCommonFilterParent,
    onToggleFilter: toggleFilterParent
  }, null, 8, ["isArchiveEnabled", "isFilterEnabled", "isFilterSetted", "items", "is-button-disabled"]))
}
}

})